import { useState } from "react"

type ResetFunction = {
  (): void
}

type Bind<T> = {
  value: T
  onChange: (value: T) => void
}

export function useInput<T>(initialValue: T): [T, Bind<T>, ResetFunction] {
  const [value, setValue] = useState<T>(initialValue)

  const reset = () => {
    setValue(initialValue)
  }

  const bind: Bind<T> = {
    value,
    onChange: value => {
      setValue(value)
    },
  }

  return [value, bind, reset]
}
